import { Button, Theme, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const RoleDetailsCont = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
  marginTop: 10,
  display: 'flex',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const MediaCont = styled('div')(({ theme }) => ({
  minWidth: 230,
  maxWidth: 230,
  maxHeight: 300,
  marginRight: 10,
  overflow: 'auto',
  paddingRight: 10,
  gap: 10,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    marginTop: 10,
    maxWidth: 'unset',
    maxHeight: 'unset',
  },
}));
export const MediaSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '10px 0',
  gap: 10,
}));

export const DetailsCont = styled('div')(({ theme }) => ({
  marginBottom: 'auto',
  display: 'flex',
  gap: 10,
  flex: 1,
  padding: '10px 0 0 0',
  flexDirection: 'column',
  '& .MuiTypography-root': {
    whiteSpace: 'break-spaces',
  },
}));

export const ButtonCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
}));

export const RoleButton = styled(Button)<Theme>(({ theme }) => ({
  width: 110,
  height: 30,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));

export const RoleButtonSubmitted = styled(Button)(({ theme }) => ({
  width: 110,
  height: 30,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  backgroundColor: theme.palette.type === 'dark' ? `${COLORS.DARK_BORDER} !important` : `${COLORS.WHITE}`,
  pointerEvents: 'none',
  border: `1px solid ${COLORS.SUCCESS}`,
}));
